import handleJsonInput from "~/helpers/shared/handleJsonInput"
import buildSubgenres from "./build/subgenres"
import buildDecisions from "./build/decisions"

/**
 * @param influencer
 */
export default function (influencer) {
  const copyOfInfluencer = { ...influencer }

  return {
    ...copyOfInfluencer,
    ...buildSubgenres(copyOfInfluencer),
    ...buildDecisions(copyOfInfluencer),
  }
}
